import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchOperationalAnalysisDaily = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getOperationalAnalysisDaily',
    stub: config.useStubbedEndpoints,
  });
  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchOperationalAnalysisDaily;
